import React from 'react';

import { Block } from '../common/Block.jsx';
import { Container, HeaderText } from '../common/Container.jsx';

function DisplayHeader(props) {
    let style;
    if (props.blockConfig) {
        style = {};
        if (props.blockConfig.block) {
            Block.mapStyleConfigProps(style, props.blockConfig.block);
        }
        if (props.blockConfig.layout) {
            Block.mapStyleConfigProps(style, props.blockConfig.layout);
        }
    }
    return (
        <Container>
            <HeaderText className="layout__page__header notranslate" style={style}>{props.data}</HeaderText>
        </Container>
    );
}

export default { Component: DisplayHeader };